module.exports = __webpack_public_path__ + "img/IMG_5287.be7e857b.jpg";